import {
    getPhase,
    listPhases
} from './queries';
import {
    createPhase,
    deletePhase,
    updatePhase,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CreatePhase,
    DeletePhase,
    GetPhase,
    ListPhases,
    Phase,
    UpdatePhase
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListPhases>>({
                                                                        query: listPhases,
                                                                        variables: {
                                                                            filter: filter
                                                                        },
                                                                    });
    return response.data?.listPhases.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPhase>>({
                                                                      query: getPhase,
                                                                      variables: {id: id},
                                                                  });
    return response.data?.getPhase;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreatePhase>>({
                                                                         query: createPhase,
                                                                         variables: {input: payload},
                                                                     });
    return response.data?.createPhase;
};

export const update = async (_id: string, record: Phase) => {

    delete record.created;
    delete record.updated;
    delete record.createdByUsername
    delete record.playbook
    delete record.steps

    const response = await client.graphql<GraphQLQuery<UpdatePhase>>({
                                                                         query: (updatePhase),
                                                                         variables: {input: record},
                                                                     });
    return response.data?.updatePhase;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeletePhase>>({
                                                                         query: (deletePhase),
                                                                         variables: {input: {id: id}},
                                                                     });
    return response.data?.deletePhase;
};
